import React, { useState } from 'react';

import CloseIcon from '../assets/icons/x-circle.svg';

interface TooltipProps {
  closeTooltip: () => void;
}

export const TOOLTIP_TEXT = "Hi, I'm ALEX Chat! I can answer common benefits questions.";

function Tooltip({ closeTooltip }: TooltipProps): JSX.Element {
  const [closing, setClosing] = useState(false);

  const onClick = () => {
    setClosing(true);
    setTimeout(() => {
      closeTooltip();
    }, 300);
  };

  return (
    <div className={`Tooltip${closing ? ' close' : ''}`}>
      {TOOLTIP_TEXT}
      <button
        type="button"
        className="Tooltip-close-button"
        onClick={onClick}
        data-testid="tooltip-close-button"
      >
        {/* <div className="Tooltip-close-icon"> */}
        <img src={CloseIcon} alt="Close tooltip" />
        {/* </div> */}
      </button>
    </div>
  );
}

export default Tooltip;
